import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const MessageSuccess = styled.span`
  color: ${({ theme }) => theme.colors.grey48};
  font-size: 14px;
`

export const CustomIcon = styled(Icon)`
  margin-right: 4px;
  :before {
    background-color: ${({ theme }) => theme.colors.grey48};
  }
`

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  margin-left: -4px;
`

export const CustomButton = styled(Button)`
  padding: 0;
  margin-left: 8px;
  margin-top: 4px;
`
